import { render } from "./WithdrawLogsList.vue?vue&type=template&id=05b697c6"
import script from "./WithdrawLogsList.vue?vue&type=script&lang=js"
export * from "./WithdrawLogsList.vue?vue&type=script&lang=js"

import "./WithdrawLogsList.vue?vue&type=style&index=0&id=05b697c6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__